import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'initials', standalone: true, pure: true })
export class InitialsPipe implements PipeTransform {
  transform(input: string | undefined): string {
    return input != null
      ? input
          .split(' ', 2)
          .map((n) => n[0])
          .join('')
          .toUpperCase()
      : '';
  }
}
